import { HttpsError } from './errors/HttpsError';

export function assertPositiveInteger(value: number) {
  if (!Number.isInteger(value) || value <= 0) {
    throw new HttpsError(
      'invalid-argument',
      `Value must be a positive integer`,
      { value },
    );
  }
}
